export const filterLevels = {
  reasonType: 'reasonType',
  reason: 'reason',
}

export const filterLevelOptions = t => [
  { label: t('Tipo de motivo de devolución'), value: filterLevels.reasonType },
  { label: t('Motivo de devolución'), value: filterLevels.reason },
]
